import { dateTimeFormat } from '@/utility/utility_functions'
import File from '@/classes/case/File'

export default class EmailMessage {
  constructor (id, receiver, sender, subject, content, date, attachment) {
    this.id = id
    this.receiver = receiver
    this.sender = sender
    this.subject = subject
    this.content = content
    this.date = date
    this.attachment = attachment
  }

  static asMessages (json) {
    return json.map(message => {
      return EmailMessage.asMessage(message)
    })
  }

  static asMessage (json) {
    return new EmailMessage(
      json.id,
      json.receiver,
      json.sender ? json.sender : '',
      json.subject,
      json.content,
      json.date ? dateTimeFormat(json.date) : '',
      json.attachment ? File.asFile(json.attachment) : ''
    )
  }

  get filesComponent () {
    if (this.attachment.url) {
      return { files: [this.attachment] }
    }
    return { files: [] }
  }
}
